
export default {
  setDialogVisible(state, val) {
    state.dialogVisible = val;
  },
  setUser(state, val) {
    state.user = val;
  },
  setStatus(state, val) {
    state.status = val;
  },
  setCartNum(state, num) {
    state.user.cart_num = num;
  },
  setHeaderIndex(state, val) {
    state.headerIndex = val;
  },
  updateShowSys(state, val) {
    state.showSys = val;
  },
  updateShowSysType(state, val) {
    state.sysType = val;
  },
  updateCateId(state, val) {
    state.cateId = val;
  },
  SetPercentage(state, val) {
    state.percentage = val;
  },
  setCollectMusic(state, val) {
    state.collectMusic = val;
  },
  setPutOnMusic(state,val){
    state.PutOnMusic = val
  },
  setPutOnMusicUrl(state,val){
    state.PutOnMusicUrl = val
  },
  setPause(state,val){
    state.isPause = val
  },
  SetMouseLength(state,val){
    state.mouseLength = val
  },
  SetService(state,val){
    state.service = val
  },
};
